import React, { useEffect } from 'react';
import { Element } from 'react-scroll';
import PageTopButton from '@components/common/pageTopButton';
import Banner from '@components/acca/results/common/banner';
import ResultList from '@components/acca/results/resultList';
import { useAccaTestResultStore } from '@stores/AccaTestResultStore';
import { useUserInfo } from '@repository/auth/useUserInfo';
import Result from './result';
import TipList from './tipList';
import classnames from 'classnames/bind';
import styles from './accaResults.module.scss';

const cx = classnames.bind(styles);

// 내 프로필 > 역검 결과
const AccaResults = () => {
  const { data: userInfo } = useUserInfo();
  const fetchAccResults = useAccaTestResultStore((state) => state.fetchAccResults);

  useEffect(() => {
    if (!userInfo) return;
    if (fetchAccResults) fetchAccResults();
  }, [userInfo]);

  return (
    <Element name={'result'} className={cx('resultArea')}>
      <div className={cx('resultWrap')}>
        <div className={cx('contentsArea')}>
          <div className={cx('contentsWrap')}>
            {/* 넛지 메세지 */}
            <TipList />
            {/* 역검 결과 리스트 */}
            <ResultList />
            {/* 역검 결과표 */}
            <Result />
          </div>
          {/* 배너 */}
          <Banner />
        </div>
      </div>
      <PageTopButton />
    </Element>
  );
};

export default AccaResults;
